'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
import SimpleBar from 'simplebar';

/**
 * module
 */
import { anchor } from './module/_anchor';
// import { carousel } from './module/_carousel';
import { fitimg } from './module/_fitimg';
import { header } from './module/_header';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
// import { justHeight } from './module/_justHeight';
// import { modal } from './module/_modal';
import { responsive } from './module/_responsive';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(() => {
            $('body').addClass('is-loaded');
        }, 300);
    };

    /**
     * init
     */
    const init = () => {
        anchor.init();
        // carousel.init();
        fitimg.init();
        header.init();
        hover.init();
        inview.init();
        // justHeight.init();
        // modal.init();
        responsive.init();

        $(window).on('load resize scroll', () => {
            setTimeout(() => {
                $('.js-scrBar').each((index, element) => {
                    const $this = $(element).find('.js-scrBar-wrap');
                    $this.css('height', 'auto');
                    let scrH = $this.height();
                    $this.css('height', scrH);
                });
            }, 100);
        });

        $('.js-scrBar').each((index, element) => {
            new SimpleBar(element, {
                autoHide: false
            });
        });
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
